
import React from 'react';
import { Link } from 'react-router-dom';
import {
    Row,
    Col,
} from "reactstrap"
import PropTypes from 'prop-types'

function CustomerTableItem(props) {
    const { data, count } = props;
    return (
        <tr>
            <td scope="row">{count}</td>
            <td>{data.customer_name}</td>
            <td>{data.customer_address}</td>
            <td>{data.customer_phone}</td>
            <td>
                <Row className="d-flex align-items-center m-0">
                    <Col xs="auto" sm="auto">
                        <Link className='text-success' to={"/customers/"+data.customer_id} >
                            <i className="fas fa-pen"></i>
                        </Link>
                    </Col>
                </Row>
            </td>
        </tr>
    )

}
CustomerTableItem.propTypes = {
    data: PropTypes.object,
    count: PropTypes.number
}

export default CustomerTableItem;
